import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from '@/components/ui/sonner';
import { useVisitorTracking } from '@/hooks/useVisitorTracking';
import { WatermarkProvider } from '@/context/WatermarkContext';
import IPBlockGuard from '@/components/IPBlockGuard';
import Home from '@/pages/Home';
import AvailableKittens from '@/pages/AvailableKittens';
import KittenDetail from '@/pages/KittenDetail';
import AboutUs from '@/pages/AboutUs';
import AdoptionProcess from '@/pages/AdoptionProcess';
import Gallery from '@/pages/Gallery';
import Videos from '@/pages/Videos';
import Contact from '@/pages/Contact';
import FAQ from '@/pages/FAQ';
import AdminDashboard from '@/pages/AdminDashboard';
import AdminLogin from '@/pages/AdminLogin';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import ChatWidget from '@/components/ChatWidget';
import NoDepositBanner from '@/components/NoDepositBanner';
import AntiScamBanner from '@/components/AntiScamBanner';

function AppContent() {
  useVisitorTracking();
  const location = useLocation();
  
  // Don't show header/footer on admin pages
  const isAdminPage = location.pathname.startsWith('/admin');
  
  return (
    <>
      {!isAdminPage && <NoDepositBanner />}
      {!isAdminPage && <Header />}
      {!isAdminPage && <AntiScamBanner />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/kittens" element={<AvailableKittens />} />
        <Route path="/kittens/:id" element={<KittenDetail />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/adoption-process" element={<AdoptionProcess />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/login" element={<AdminLogin />} />
      </Routes>
      {!isAdminPage && <Footer />}
      {!isAdminPage && <ChatWidget />}
      <Toaster position="top-center" richColors />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <WatermarkProvider>
        <IPBlockGuard>
          <div className="App min-h-screen bg-stone-50">
            <BrowserRouter>
              <AppContent />
            </BrowserRouter>
          </div>
        </IPBlockGuard>
      </WatermarkProvider>
    </HelmetProvider>
  );
}

export default App;
